export const OPTIONAL_REQUIRED_FIELD = 'Optional'
export const REQUIRED_REQUIRED_FIELD = 'Required'
export const PROHIBITED_REQUIRED_FIELD = 'Prohibited'

export const OPTIONAL_COLUMN_WARNING =
  'For metadata in your model, districts must supply the column within their file even when populating the field value is optional.'
